export default class ApplicationStatus {
  static readonly APPLIED = "applied";
  static readonly DOING = "doing";
  static readonly DONE = "done";
  static readonly EVALUATED = "evaluated";
  static readonly CANCELED = "canceled";
  static readonly REQESTED_CANCEL = "requested_cancel";
  static readonly ATTENDANCE_UNAPPROVED = "attendance_unapproved";
}
